"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _Icon = require("../Icon");
var _excluded = ["children", "className", "disabled", "error", "id", "onBlur", "onChange", "onClick", "value"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
// Should be kept in sync with the value in Dropdown.styles.dropdown-options
var CLOSE_OPTIONS_TRANSITION_TIME = 100;
var CustomDropdown = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    error = _ref.error,
    id = _ref.id,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? _lodash.noop : _ref$onBlur,
    onChange = _ref.onChange,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? _lodash.noop : _ref$onClick,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  // Refers to index of option highlighted in options menu
  var _useState = (0, _react.useState)(value ? children.findIndex(function (child) {
      return child.props.value === value;
    }) : null),
    _useState2 = _slicedToArray(_useState, 2),
    highlightedIndex = _useState2[0],
    setHighlightedIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isShowingOptions = _useState4[0],
    setIsShowingOptions = _useState4[1];
  var menuRef = (0, _react.useRef)(null);
  var highlightedRef = (0, _react.useRef)();
  var handleOptionMouseDown = function handleOptionMouseDown(_ref2) {
    var index = _ref2.index,
      value = _ref2.value;
    setHighlightedIndex(index);
    onChange(value);
    // When options menu closes immediately, it's a little jarring
    // so close options menu after a small delay
    setTimeout(function () {
      return setIsShowingOptions(false);
    }, CLOSE_OPTIONS_TRANSITION_TIME);
  };

  // After new highlightedIndex has been set,
  // center highlighted option vertically in menu
  (0, _react.useEffect)(function () {
    if (menuRef.current && highlightedRef.current && isShowingOptions) {
      // This method ensures that only menu is scrolled
      // instead of whole page (which is what happend with scrollIntoView)
      menuRef.current.scrollTop = highlightedRef.current.offsetTop - menuRef.current.offsetHeight / 2 + highlightedRef.current.offsetHeight / 2;
    }
  }, [highlightedIndex, isShowingOptions]);
  var handleDropdownKeyDown = function handleDropdownKeyDown(e) {
    var key = e.key;
    switch (key) {
      case 'ArrowDown':
      case 'Down':
        {
          if (!isShowingOptions) {
            break;
          }
          // May not change depending on position in options and disabled options
          var newIndex = highlightedIndex;
          var indexToCheck = (0, _lodash.isNil)(newIndex) ? 0 : newIndex + 1;
          while (children[indexToCheck]) {
            if (!children[indexToCheck].props.disabled) {
              newIndex = indexToCheck;
              break;
            }
            indexToCheck += 1;
          }
          setHighlightedIndex(newIndex);
          break;
        }
      case 'ArrowUp':
      case 'Up':
        {
          if (!isShowingOptions || (0, _lodash.isNil)(highlightedIndex)) {
            break;
          }
          // May not change depending on position in options and disabled options
          var _newIndex = highlightedIndex;
          var _indexToCheck = _newIndex - 1;
          while (children[_indexToCheck]) {
            if (!children[_indexToCheck].props.disabled) {
              _newIndex = _indexToCheck;
              break;
            }
            _indexToCheck -= 1;
          }
          setHighlightedIndex(_newIndex);
          break;
        }
      case ' ':
      case 'Spacebar':
        {
          /**
           * In native select elements, Spacebar can expand/close the options menu
           * and also select options
           */
          e.preventDefault();
          if (!(0, _lodash.isNil)(highlightedIndex)) {
            onChange(children[highlightedIndex].props.value);
          }
          setIsShowingOptions(!isShowingOptions);
          break;
        }
      case 'Enter':
        {
          if (isShowingOptions) {
            /**
             * If options are showing and input is wrapped in a form,
             * Enter should close the options without submitting the form
             * so prevent the default form action when isShowingOptions is true
             */
            e.preventDefault();
            if (!(0, _lodash.isNil)(highlightedIndex)) {
              onChange(children[highlightedIndex].props.value);
            }
            setIsShowingOptions(false);
          }
          break;
        }
      default:
        {
          break;
        }
    }
  };
  var handleDropdownClick = function handleDropdownClick(e) {
    setIsShowingOptions(!isShowingOptions);
    onClick(e);
  };
  var handleDropdownBlur = function handleDropdownBlur(e) {
    setIsShowingOptions(false);
    onBlur(e);
  };
  var selectedOption = children.find(function (c) {
    return c.props.value === value;
  });
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    "aria-expanded": isShowingOptions,
    "aria-haspopup": true,
    "aria-labelledby": id,
    className: (0, _classnames.default)('dropdown relative outline-none', {
      'dropdown-invalid': error && !disabled
    }, className),
    disabled: disabled,
    onBlur: handleDropdownBlur,
    onClick: handleDropdownClick,
    onKeyDown: handleDropdownKeyDown,
    ref: ref
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-select tw-body-sm-regular"
  }, selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.props.children), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: "caret-down-medium-16",
    className: "text-black"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('dropdown-options', 'text-black', 'absolute top-[calc(100%+6px)] left-0 w-full', 'card shadow-10 bg-white z-10', 'flex flex-col select-none max-h-[224px] py-[8px] overflow-auto',
    // Properties that are animated on open/close
    // Set visibility so that elements are non-interactable
    isShowingOptions ? 'visible opacity-100' : 'invisible opacity-0'),
    ref: menuRef
  }, children.map(function (option, index) {
    return /*#__PURE__*/_react.default.cloneElement(option, {
      onMouseDown: handleOptionMouseDown,
      isHighlighted: index === highlightedIndex,
      isSelected: option.props.value === value,
      highlightedRef: highlightedRef,
      index: index
    });
  })));
});
exports.CustomDropdown = CustomDropdown;